import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../../firebase.init";
import { signOut } from "firebase/auth";
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { createPopper } from '@popperjs/core';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Bootstrap's JS includes Popper.js
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const NavBar = () => {
  const [user] = useAuthState(auth);
  const [users, setUsers] = useState([]);
  const [logo, setLogo] = useState([]);
  const [profile, setProfile] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const handleSignOut = () => {
    signOut(auth)
      .then(() => {
        navigate('/'); // Navigate to the home page after successful sign-out
      })
      .catch((error) => {
        console.error('Sign out error: ', error);
      });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const logoResponse = await fetch("https://aprilone-178ea8362c0b.herokuapp.com/logo");
        const logoData = await logoResponse.json();
        setLogo(logoData);

        const usersResponse = await fetch("https://aprilone-178ea8362c0b.herokuapp.com/users");
        const usersData = await usersResponse.json();
        setUsers(usersData);

        const profileResponse = await fetch("https://aprilone-178ea8362c0b.herokuapp.com/profiles/");
        const profileData = await profileResponse.json();
        setProfile(profileData);
      } catch (err) {
        setError("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);



  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const button = document.querySelector('#button');
  const tooltip = document.querySelector('#tooltip');

  const popperInstance = createPopper(button, tooltip, {
    placement: 'right', // Adjust the position as needed
  });

  return (


    <>
      <div className="header-bg-img">
        <header>
          <div className="container">
            <nav className="navbar navbar-expand-lg navbar-light">
              {
                logo.map(l => <a className="navbar-brand" href="/">
                  <figure className="mb-0">
                    <img src={l.logo} alt="" className="img-fluid" />
                  </figure>
                </a>)
              }

              <button className="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon" />
                <span className="navbar-toggler-icon" />
                <span className="navbar-toggler-icon" />
              </button>
              <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav ml-auto">
                  <li className="nav-item active"><a className="nav-link text-white" href="/">Home</a></li>
                  <li className="nav-item"><a className="nav-link text-white" href="#services-sec">Services</a></li>
                  {/* <li className="nav-item"><a className="nav-link text-white" href="/blog">Blog</a></li> */}
                  <li className="nav-item"><a className="nav-link text-white" href="#pricing-sec">Pricing</a></li>
                  <li className="nav-item"><a className="nav-link text-white" href="#contact-sec">Contact Us</a></li>
                  <li className="nav-item" >  <div className="menu-right-content d-flex ">
                    {user?.email ? (
                      <>
                        {/* {profile.map(
                          (pro) =>
                            pro.userEmail === user?.email && (
                              <div className="nav-item dropdown me-3" key={pro._id}>
                                <a
                                  className="nav-link dropdown-toggle"
                                  href=""
                                  role="button"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <img
                                    src={
                                      pro.profileImg ||
                                      "https://st3.depositphotos.com/15648834/17930/v/450/depositphotos_179308454-stock-illustration-unknown-person-silhouette-glasses-profile.jpg"
                                    }
                                    alt="Profile"
                                    className="rounded-circle me-2"
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "50%",
                                    }}
                                  />
                                </a>
                                <ul className="dropdown-menu dropdown-menu-end p-3 mt-3">
                                  <li>
                                    <Link className="dropdown-item paragraph" to="/dashboard">
                                      <i className="fa-solid fa-bars text-primary" ></i> Dashboard
                                    </Link>
                                  </li>
                                  <li>
                                    <Link className="dropdown-item paragraph" to="/my-order/">
                                      <i className="fa-solid fa-cart-shopping text-primary"></i> My Orders
                                    </Link>
                                  </li>
                                  <li>
                                    <hr className="dropdown-divider " />
                                  </li>
                                  <li className="paragraph">
                                    <i className="fa-solid fa-user text-primary"></i> {pro.userName}
                                  </li>
                                  <li className="paragraph">{pro.userEmail}</li>
                                  <Link to={`/update-profile/${pro._id}`} className="mt-2 mb-2 paragraph">
                                    Edit Profile
                                    <span className="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle"></span>
                                  </Link>
                                  <li>
                                    <hr className="dropdown-divider" />
                                  </li>
                                  <li>
                                    <button className="dropdown-item paragraph" onClick={handleSignOut}>
                                      <i className="fa-solid fa-right-from-bracket text-primary"></i> Logout
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            )
                        )} */}

                        <li className="nav-item d-flex align-items-center">
                          <Link to="/dashboard">
                            <img
                              src={

                                "https://st3.depositphotos.com/15648834/17930/v/450/depositphotos_179308454-stock-illustration-unknown-person-silhouette-glasses-profile.jpg"
                              }
                              alt="Profile"
                              className="rounded-circle "
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                              }}
                            />
                          </Link>
                        </li>

                      </>
                    ) : (
                      <ul className="list-unstyled">
                        <li className="nav-item d-flex align-items-center">
                          <Link to="/login" className=" button-professional ">
                            Log in
                          </Link>
                        </li>
                      </ul>
                    )}

                    <div className="side-item ">
                      {users.map(
                        (u, index) =>
                          u.userEmail === user?.email &&
                          u.userRole === "Admin" && (
                            <li className=" paragraph d-flex align-items-center" key={index}>
                              <Link to="/admin" className="button-professional ">
                                Admin
                              </Link>
                            </li>
                          )
                      )}
                    </div>
                  </div></li>
                </ul>
              </div>
            </nav>
          </div>
        </header>
      </div>
    </>
  );
};

export default NavBar;
